import { getFormattedGroups } from '@sdk/personaCollection/utils/personaCollection.utils';
import { User } from '@sdk/users/types/User';

const GROUP_TITLE_CHARACTER_LIMIT = 23;

export const getUserFormattedGroups = (user: User, maxLength = GROUP_TITLE_CHARACTER_LIMIT) => {
  const locationTitle = getFormattedGroups(user.locations, {
    maxLength,
  });

  const positionTitle = getFormattedGroups(user.positions, {
    maxLength,
  });

  let text = locationTitle;
  if (positionTitle) {
    text += text ? ` • ${positionTitle}` : positionTitle;
  }

  return text;
};
